import { useEffect, useState } from "react";
import cloudflare from "@/integrations/cloudflare/client";

const TestCustomers = () => {
  const [status, setStatus] = useState("Loading...");
  const [customers, setCustomers] = useState<any[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const testApi = async () => {
      try {
        console.log("Testing API with URL:", cloudflare.apiUrl);
        setStatus(`Fetching from ${cloudflare.apiUrl}/api/v1/customers...`);

        const response = await fetch(`${cloudflare.apiUrl}/api/v1/customers?limit=5`);
        console.log("Response status:", response.status);
        console.log("Response headers:", response.headers);

        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }

        const data = await response.json();
        console.log("Response data:", data);

        if (data.data) {
          setCustomers(data.data);
          setStatus(`Success! Found ${data.data.length} customers`);
        } else {
          setError("No data property in response");
          setStatus("Error: Invalid response format");
        }
      } catch (err) {
        console.error("Error fetching customers:", err);
        setError(err instanceof Error ? err.message : "Unknown error");
        setStatus("Error occurred");
      }
    };

    testApi();
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold mb-4">Customer API Test Page</h1>

      <div className="mb-4">
        <p className="font-semibold">API URL:</p>
        <code className="bg-gray-100 p-2 rounded">{cloudflare.apiUrl}</code>
      </div>

      <div className="mb-4">
        <p className="font-semibold">Status:</p>
        <p className={error ? "text-red-600" : "text-green-600"}>{status}</p>
      </div>

      {error && (
        <div className="mb-4 p-4 bg-red-100 rounded">
          <p className="font-semibold text-red-800">Error Details:</p>
          <p className="text-red-600">{error}</p>
        </div>
      )}

      {customers.length > 0 && (
        <div>
          <p className="font-semibold mb-2">Customers Found:</p>
          <ul className="list-disc pl-5">
            {customers.map((customer: any) => (
              <li key={customer.id}>
                {customer.first_name} {customer.last_name} - {customer.email}
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="mt-4">
        <p className="text-sm text-gray-600">Check the browser console for detailed logs</p>
      </div>
    </div>
  );
};

export default TestCustomers;
